import { render, staticRenderFns } from "./RptDevServChgDet.vue?vue&type=template&id=093232a7&scoped=true"
import script from "./RptDevServChgDet.vue?vue&type=script&lang=js"
export * from "./RptDevServChgDet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "093232a7",
  null
  
)

export default component.exports